<template>
  <div>
    <ResourceNavbar
      :selected="selected"
      @navSelect="id => handleNavSelect(id)"
    />

    <div v-if="selected === 'Connect'">
      <BoxInfo
        v-if="selected_box"
        :id="selected_box"
        @back="handleBack()"
      />
      <BoxList
        v-else
        @rowClick="id => handleRowClick(id)"
      />
    </div>

    <div v-else-if="selected === 'SFTP'">
      <ResourceUsers
        v-if="selected_resource"
        :id="selected_resource"
        @back="handleResourceBack()"
      />
      <ResourceList
        v-else
        @rowClick="id => handleResourceRowClick(id)"
      />
    </div>
    <DeploymentDashboard
      v-else-if="selected === 'DeploymentDashboard'"
    />
  </div>
</template>

<script>
import BoxList from './BoxList.vue'
import BoxInfo from './BoxInfo/BoxInfo.vue'
import ResourceList from './ResourceList.vue'
import ResourceUsers from './ResourceUsers.vue'
import ResourceNavbar from './NavBar.vue'
import DeploymentDashboard from './DeploymentDashboard.vue'

export default {
  name: 'PageLayout',
  components: {
    ResourceNavbar,
    BoxList,
    BoxInfo,
    ResourceList,
    ResourceUsers,
    DeploymentDashboard
  },
  data() {
    return {
      selected_box: null,
      selected_resource: null,
      selected: 'Connect'
    }
  },
  methods: {
    handleRowClick(id) {
      this.selected_box = id
    },
    handleBack() {
      this.selected_box = null
    },
    handleResourceRowClick(id) {
      this.selected_resource = id
    },
    handleResourceBack() {
      this.selected_resource = null
    },
    handleNavSelect(id) {
      this.selected = id
      this.selected_box = null
      this.selected_resource = null
    }
  }
}
</script>